import React from 'react'
import DOMPurify from 'dompurify'

interface PriceRow {
  value: string
}

interface PriceColumn {
  title: string
  rows: PriceRow[]
}

interface InsuranceSectionTablePricesProps {
  title: string
  subTitle?: string
  description?: string
  footerDescription?: string
  backgroundColor?: string
  columns: PriceColumn[]
}

const InsuranceSectionTablePrices: React.FC<
  InsuranceSectionTablePricesProps
> = ({
  title,
  subTitle,
  description,
  footerDescription,
  backgroundColor,
  columns,
}) => {
  return (
    <section
      className="w-full max-w-[1142px] mx-auto flex justify-center md:py-10 py-10"
      style={{ background: backgroundColor }}
    >
      <div className="w-full max-w-[980px] px-6">
        <h2 className="text-[#101010] md:text-[32px] text-2xl md:font-bold font-medium mb-4">
          {title}
        </h2>
        {subTitle && (
          <h3 className="text-[#101010] md:text-lg text-base md:font-bold font-normal mb-2">
            {subTitle}
          </h3>
        )}
        {description && (
          <p
            className="text-[#616161] md:text-base text-sm font-normal mb-3 sm:mb-6"
            dangerouslySetInnerHTML={{
              __html:
                typeof DOMPurify?.sanitize === 'function'
                  ? DOMPurify?.sanitize(description)
                  : description,
            }}
          />
        )}
        <div className="overflow-x-auto">
          <table className="w-full bg-transparent rounded border-separate border-spacing-0">
            <thead>
              <tr>
                {columns.map((col, idx) => (
                  <th
                    key={idx}
                    className="text-left py-3 px-4 text-[#101010] text-xs font-normal border-b border-[#E1E0DF] bg-transparent"
                  >
                    {col.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {columns[0].rows.map((_, rowIdx) => (
                <tr key={rowIdx} className="border-b border-[#E1E0DF]">
                  {columns.map((col, colIdx) => (
                    <td
                      key={colIdx}
                      className="py-3 px-4 text-[#101010] text-xs font-normal border-b border-[#E1E0DF]"
                    >
                      {col.rows[rowIdx]?.value}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {footerDescription && (
          <div
            className="text-[#616161] text-xs mt-6 leading-relaxed"
            dangerouslySetInnerHTML={{
              __html:
                typeof DOMPurify?.sanitize === 'function'
                  ? DOMPurify?.sanitize(footerDescription)
                  : footerDescription,
            }}
          />
        )}
      </div>
    </section>
  )
}

export default InsuranceSectionTablePrices
